import React from 'react'
import { useDispatch } from 'react-redux';
import { cookieSwitch } from '../../reducers/ToggleAction';
import "./popUp.css"
import { AiOutlineClose } from "react-icons/ai"

const Cookie = () => {

  const dispatch = useDispatch();
        
  

  return (
    <div  id='popup'>
      
     <div  id="popup-div">
     <div id='popup-head' >
      <p id='close-div' className='flex justify-end'>
        <span onClick={()=>dispatch(cookieSwitch())}><AiOutlineClose color='black' /></span>
        </p>
          <h2 className='border-l-0  text-black'>COOKIE POLICY </h2>
          <p>This Cookie Policy explains how Vwrap ("we" or "us") uses cookies and similar technologies when you visit our website (the "Website"). By using the Website, you agree to the use of cookies and similar technologies in accordance with this Cookie Policy.</p>
     </div>
     <div id='popup-body'>
      <h3>1- <span> WHAT ARE COOKIES?</span></h3>
       <p>Cookies are small text files that are placed on your device (computer, tablet, or mobile phone) when you visit a website. Cookies can be used to store and receive information about your use of the Website.</p>
      
      <h3>2- TYPES OF COOKIES WE USE</h3>
      <p>We use the following types of cookies on the Website:
      <ul>
         <br/>
            <li>- Strictly necessary cookies: these cookies are essential to enable you to use the Website and its features.</li>
            <li>- Performance cookies: these cookies help us to understand how you use the Website, so we can improve the performance and functionality of the Website.</li>
            <li>- Functionality cookies: these cookies enable us to remember your preferences, such as your language and location, and provide you with a personalized experience on the Website.</li>
            <li>- Targeting cookies: these cookies are used to deliver personalized advertising to you based on your interests and browsing behavior.</li>
        </ul>
      </p>

      <h3>3- THIRD-PARTY COOKIES</h3>
      <p>We may use third-party cookies on the Website, including but not limited to Google Analytics and Facebook Pixel. These third-party cookies are used to collect information about your use of the Website, such as the pages you visit and the links you click on, and to deliver targeted advertising to you on other websites.</p>

      <h3>4- COOKIE MANAGEMENT</h3>
      <p>Most web browsers allow you to control cookies through their settings preferences. You can set your browser to refuse all cookies, or to alert you when cookies are being sent. However, please note that some features of the Website may not function properly if you disable cookies.</p>

      <h3>5- CHANGES TO THIS COOKIE POLICY</h3>
      <p>We may update this Cookie Policy from time to time. Any changes will be effective immediately upon posting of the updated Cookie Policy on the Website.</p>


      <h3>6- CONTACT Us</h3>
      <p>If you have any questions or concerns about this Cookie Policy or our use of cookies, please contact us at the following email address: info@vwrap.com.</p>



     </div>
     </div>
    </div>
  )
}

export default Cookie
